<div class="grid">
    <que-manipulations-toolbar [isEmpty]="isEmpty$()"></que-manipulations-toolbar>
    <div class="scroll" [ngClass]="{ expanded: !isFilterListOpen$()}" *ngIf="isResult$(); else thereIsNotResult">
        <que-approvals-list-header class="position-sticky" [sortBy]="sort().sortBy"
            [sortDirection]="sort().sortDirection" (sortChange)="onSortChange($event)">
        </que-approvals-list-header>
        <div *ngFor="let item of approvals$()?.result">
            <que-approvals-list-item [approval]="item"></que-approvals-list-item>
        </div>
        <ng-container *ngFor="let _ of [].constructor(3)">
            <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
        </ng-container>
    </div>
    <que-approvals-bulk-action-bar *ngIf="pendingApprovalTab$()"></que-approvals-bulk-action-bar>
</div>
<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$(); else loading">
        <que-no-result [isEmpty]="isEmpty$()" [type]="'approvals'"></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result" *ngIf="loading$()">
        <div *ngFor="let _ of [].constructor(10)" class="item-in-loading load-enimation"></div>
    </div>
</ng-template>